import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Qualcosa è andato storto";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const STATUS_LABEL = {
  in_attesa_pagamento: "In attesa di pagamento",
  ricevuto: "Ricevuto",
  in_lavorazione: "In lavorazione",
  spedito: "Spedito",
  consegnato: "Consegnato",
  annullato: "Annullato",
};
